var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderDashWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15081_24449)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15081_24449",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 2.66668C7.52156 2.66668 7.05868 2.72955 6.61884 2.84712L6.27452 1.55901C6.82566 1.41169 7.40427 1.33334 8.00016 1.33334C8.59605 1.33334 9.17466 1.41169 9.7258 1.55901L9.38148 2.84712C8.94165 2.72955 8.47876 2.66668 8.00016 2.66668Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33355 3.38002C4.52397 3.84844 3.84859 4.52382 3.38017 5.3334L2.22609 4.66566C2.8113 3.65422 3.65437 2.81115 4.66581 2.22594L5.33355 3.38002Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6202 5.3334C12.1517 4.52382 11.4764 3.84844 10.6668 3.38002L11.3345 2.22594C12.346 2.81115 13.189 3.65422 13.7742 4.66566L12.6202 5.3334Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 8.00001C13.3335 7.52141 13.2706 7.05852 13.1531 6.61869L14.4412 6.27437C14.5885 6.82551 14.6668 7.40412 14.6668 8.00001C14.6668 8.5959 14.5885 9.17451 14.4412 9.72565L13.1531 9.38133C13.2706 8.9415 13.3335 8.47861 13.3335 8.00001Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84727 6.61869C2.7297 7.05852 2.66683 7.52141 2.66683 8.00001C2.66683 8.47861 2.7297 8.9415 2.84727 9.38133L1.55916 9.72565C1.41184 9.17451 1.3335 8.5959 1.3335 8.00001C1.3335 7.40412 1.41184 6.82551 1.55916 6.27437L2.84727 6.61869Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38017 10.6666C3.84859 11.4762 4.52397 12.1516 5.33355 12.62L4.66581 13.7741C3.65437 13.1889 2.8113 12.3458 2.22609 11.3344L3.38017 10.6666Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 12.62C11.4764 12.1516 12.1517 11.4762 12.6202 10.6666L13.7742 11.3344C13.189 12.3458 12.346 13.1889 11.3345 13.7741L10.6668 12.62Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61884 13.1529C7.05868 13.2705 7.52156 13.3333 8.00016 13.3333C8.47876 13.3333 8.94165 13.2705 9.38148 13.1529L9.7258 14.441C9.17466 14.5883 8.59605 14.6667 8.00016 14.6667C7.40428 14.6667 6.82566 14.5883 6.27452 14.441L6.61884 13.1529Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15081_24449)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15081_24449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderDashWhite);
export default __webpack_public_path__ + "static/media/loaderDashWhite.9e11109debe6507ec154dc97b198c77d.svg";
export { ForwardRef as ReactComponent };